/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const transfer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.045 10.182H15m-2.227 2.227L15 10.182m0 0-2.227-2.227M8.955 5.727H1m2.227 2.228L1 5.727m0 0L3.227 3.5"
    />
  </svg>
)
export default transfer
